import { missionHeaderStyleMap } from '../../../../ui/features/mission-list/utils';
import { Box, Card, Typography } from '@mui/material';
import React from 'react';
export const MissionBox = ({ headerTitle, missionId, missionStatus, children, additionalHeaderInfo, headerDescriptionId, }) => {
    return (React.createElement(Card, { sx: {
            overflow: 'hidden',
            mb: 2,
        }, variant: 'outlined', "data-test": `mission-box-${missionId}` },
        React.createElement(Box, { id: headerDescriptionId, sx: {
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: { xs: 'center', sm: 'space-between' },
                alignItems: { xs: 'flex-start', sm: 'center' },
                gap: { xs: 2 },
                p: 2,
                color: missionHeaderStyleMap[missionStatus],
            } },
            React.createElement(Typography, { variant: 'overline', "data-test": 'mission-header-title' }, headerTitle),
            additionalHeaderInfo),
        React.createElement(Box, null, children)));
};
